const CONDITION_STATES = Object.freeze({
  IS_EQUAL_TO: 1,
  IS_NOT_EQUAL_TO: 2,
  IS_EMPTY: 3,
  IS_FILLED: 4,
  IS_LESS_THAN: 5,
  IS_GREATER_THAN: 6
});

export {CONDITION_STATES}




// WEBPACK FOOTER //
// ./src/enums/conditionStates.js